/**
 * 全局数据
 */
const state = ({
    dateAndPeople:[]
})

const mutations = {
    setDatePeople(state, obj) {
        state.dateAndPeople=obj;
    }
   
}

const actions = {
   
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}

